{
  "public.detail": {
    "search.placeholder": "Search shortlist",
    "hero.shortlistBy": "Shortlist by {{name}}",
    "empty.title": "No one shortlisted",
    "empty.description": "Build your shortlist by selecting resources to present to stakeholders",
    "filters.label": "Filters",
    "item.emptyValue": "n/a",
    "passwordProtection": {
      "enterPassword": "Enter password to view shortlist",
      "placeholder": "Enter password",
      "viewShortlist": "View Shortlist"
    },
    "error": {
      "title": "Error searching shortlist"
    }
  },
  "GenericSearchFilterItem": {
    "filters": {
      "belongsToMe": "Belongs to me",
      "createdAt": "Created after {{date}}",
      "publishedOnly": "Published Only",
      "draftOnly": "Draft Only",
      "archived": "Show Archived",
      "contactId": "Resource {{contact}}",
      "between": "Between {{startDate}} - {{endDate}}",
      "tags": {
        "and": " and ",
        "more": " more",
        "any": "Any tag: {{tag}}",
        "match": "Match tags: {{tags}}"
      }
    }
  },
  "GridViewItemGallery": {
    "editGallery": "Edit Gallery",
    "emptyGalleryTitle": "Empty gallery",
    "emptyGalleryDescription": "Add media for this resource",
    "addMedia": "Add media"
  },
  "ShortlistVotes": {
    "upvote": "Upvote",
    "downvote": "Downvote"
  },
  "ShortlistMediaSidebarPage": {
    "draft": "Draft",
    "votingDisabled": "Voting is disabled when the shortlist is not published",
    "commentingDisabled": "Commenting is disabled when the shortlist is not published",
    "votingAndCommentingDisabled": "Voting and commenting are disabled when the shortlist is not published"
  },
  "MediaSidebar": {
    "Header": {
      "shortlistedCount": "SHORTLISTED {{count}} OF {{totalBlocks}}"
    },
    "ResourceInfo": {
      "showDetails": "Details",
      "hideDetails": "Hide"
    },
    "CommentList": {
      "noComments": "No Comments",
      "startConversation": "Start a conversation about this person with team members"
    },
    "CommentInput": {
      "writeComment": "Write a comment",
      "addComment": "Add Comment"
    },
    "GuestNameChangeForm": {
      "title": "Guest Feedback",
      "description": "Enter your name below to leave feedback",
      "placeholder": "Your name",
      "saveChanges": "Save Changes"
    },
    "GuestInfo": {
      "youAre": "You are {{name}}",
      "change": "Change"
    }
  },
  "SetGuestNameModal": {
    "title": "Set a guest name",
    "description": "You need to tell the shortlist owner who you are before you can vote or comment on people in the shortlist",
    "yourName": "Your name",
    "saveName": "Save Name",
    "successfullyCreated": "Successfully created",
    "guestNameSet": "Guest name set"
  }
}
